"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findNested = exports.DropDownItems = exports.ClayDropDownContext = void 0;
var _form = require("@clayui/form");
var _icon = _interopRequireDefault(require("@clayui/icon"));
var _shared = require("@clayui/shared");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _warning = _interopRequireDefault(require("warning"));
var _Divider = _interopRequireDefault(require("./Divider"));
var _DropDown = _interopRequireDefault(require("./DropDown"));
var _DropDownContext = require("./DropDownContext");
var _FocusMenu = require("./FocusMenu");
var _Group = _interopRequireDefault(require("./Group"));
var _excluded = ["checked", "onChange"],
  _excluded2 = ["child", "label", "onClick", "spritemap"],
  _excluded3 = ["items", "label", "spritemap"],
  _excluded4 = ["value"],
  _excluded5 = ["items", "role", "spritemap"],
  _excluded6 = ["type"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var findNested = exports.findNested = function findNested(items, key) {
  return items.some(function (item) {
    if (item[key]) {
      return true;
    }

    // Ignore the search if the nested items are part of a contextual submenu
    // because it will be in another menu and the current menu does not need
    // to know the information of what exists inside the contextual one, like
    // knowing if there is an icon.
    if (item.items && item['type'] !== 'contextual') {
      return findNested(item.items, key);
    }
    return false;
  });
};
var Checkbox = function Checkbox(_ref) {
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    _ref$onChange = _ref.onChange,
    _onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(checked),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useContext = (0, _react.useContext)(_DropDownContext.DropDownContext),
    tabFocus = _useContext.tabFocus;
  return /*#__PURE__*/_react.default.createElement(_DropDown.default.Section, {
    role: "none"
  }, /*#__PURE__*/_react.default.createElement(_form.ClayCheckbox, _extends({}, otherProps, {
    checked: value,
    onChange: function onChange() {
      setValue(function (val) {
        return !val;
      });
      _onChange(!value);
    },
    tabIndex: !tabFocus ? -1 : undefined
  })));
};
var ClayDropDownContext = exports.ClayDropDownContext = /*#__PURE__*/_react.default.createContext({
  close: function close() {}
});
var Item = function Item(_ref2) {
  var child = _ref2.child,
    label = _ref2.label,
    _onClick = _ref2.onClick,
    spritemap = _ref2.spritemap,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var _useContext2 = (0, _react.useContext)(ClayDropDownContext),
    back = _useContext2.back,
    close = _useContext2.close,
    messages = _useContext2.messages,
    onForward = _useContext2.onForward;
  return /*#__PURE__*/_react.default.createElement(_DropDown.default.Item, _extends({}, props, {
    onClick: function onClick(event) {
      if (onForward && child && label) {
        event.preventDefault();
        onForward(label, child);
        return;
      }
      if (_onClick) {
        _onClick(event);
      }
      close();
    },
    onKeyDown: function onKeyDown(event) {
      if (back && event.key === _shared.Keys.Left) {
        back();
      }
    },
    spritemap: spritemap
  }), label, child && /*#__PURE__*/_react.default.createElement("span", {
    "aria-label": "".concat(messages['goTo'], " ").concat(label),
    className: "dropdown-item-indicator-end",
    title: "".concat(messages['goTo'], " ").concat(label)
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "angle-right"
  })));
};
var Group = function Group(_ref3) {
  var items = _ref3.items,
    label = _ref3.label,
    spritemap = _ref3.spritemap;
  "production" !== "production" ? (0, _warning.default)(typeof items !== 'undefined', "ClayDropDownWithItems -> The '".concat(label, "' group contains no items to render.")) : void 0;
  if (typeof items === 'undefined') {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_Group.default, {
    header: label
  }, items && /*#__PURE__*/_react.default.createElement(Items, {
    items: items,
    spritemap: spritemap
  }));
};
var BOTTOM_OFFSET = [0, 1];
var LEFT_OFFSET = [-1, 6];
var RIGHT_OFFSET = [1, -6];
var TOP_OFFSET = [0, -1];
var OFFSET_MAP = {
  bctc: TOP_OFFSET,
  blbr: RIGHT_OFFSET,
  bltl: TOP_OFFSET,
  brbl: LEFT_OFFSET,
  brtr: TOP_OFFSET,
  clcr: RIGHT_OFFSET,
  crcl: LEFT_OFFSET,
  tcbc: BOTTOM_OFFSET,
  tlbl: BOTTOM_OFFSET,
  tltr: RIGHT_OFFSET,
  trbr: BOTTOM_OFFSET,
  trtl: LEFT_OFFSET
};
function offsetFn(points) {
  return OFFSET_MAP[points.join('')];
}
var Contextual = function Contextual(_ref4) {
  var items = _ref4.items,
    label = _ref4.label,
    spritemap = _ref4.spritemap,
    otherProps = _objectWithoutProperties(_ref4, _excluded3);
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    visible = _useState4[0],
    setVisible = _useState4[1];
  var _useContext3 = (0, _react.useContext)(ClayDropDownContext),
    _close = _useContext3.close;
  var triggerElementRef = (0, _react.useRef)(null);
  var menuElementRef = (0, _react.useRef)(null);
  var timeoutHandleRef = (0, _react.useRef)(null);
  var keyboardRef = (0, _react.useRef)(false);
  var hasRightSymbols = _react.default.useMemo(function () {
    return items && findNested(items, 'symbolRight');
  }, [items]);
  var hasLeftSymbols = _react.default.useMemo(function () {
    return items && findNested(items, 'symbolLeft');
  }, [items]);
  var _useNavigation = (0, _shared.useNavigation)({
      activation: 'manual',
      containerRef: menuElementRef,
      loop: true,
      orientation: 'vertical',
      typeahead: true,
      visible: visible
    }),
    navigationProps = _useNavigation.navigationProps;
  var setThrottleVisible = (0, _react.useCallback)(
  // eslint-disable-next-line react-compiler/react-compiler
  (0, _shared.throttle)(function (value) {
    return setVisible(value);
  }, 100), []);
  return /*#__PURE__*/_react.default.createElement(_DropDown.default.Item, _extends({}, otherProps, {
    "aria-expanded": visible,
    "aria-haspopup": Boolean(items),
    className: (0, _classnames.default)({
      active: visible
    }),
    onClick: function onClick(event) {
      keyboardRef.current = false;
      if (event.currentTarget === event.target) {
        setVisible(true);
        clearTimeout(timeoutHandleRef.current);
        timeoutHandleRef.current = null;
      }
    },
    onKeyDown: function onKeyDown(event) {
      switch (event.key) {
        case _shared.Keys.Enter:
        case _shared.Keys.Right:
          setVisible(true);
          keyboardRef.current = true;
          break;
        default:
          break;
      }
    },
    onMouseEnter: function onMouseEnter() {
      if (!visible) {
        keyboardRef.current = false;
        timeoutHandleRef.current = setTimeout(function () {
          return setThrottleVisible(true);
        }, 400);
      }
    },
    onMouseLeave: function onMouseLeave() {
      keyboardRef.current = false;
      setThrottleVisible(false);
      clearTimeout(timeoutHandleRef.current);
      timeoutHandleRef.current = null;
    },
    ref: triggerElementRef,
    spritemap: spritemap,
    symbolRight: "angle-right"
  }), label, items && /*#__PURE__*/_react.default.createElement(_DropDown.default.Menu, {
    active: visible,
    alignElementRef: triggerElementRef,
    alignmentPosition: 8,
    hasLeftSymbols: hasLeftSymbols,
    hasRightSymbols: hasRightSymbols,
    offsetFn: offsetFn,
    onActiveChange: setVisible,
    onKeyDown: navigationProps.onKeyDown,
    ref: menuElementRef
  }, visible && /*#__PURE__*/_react.default.createElement(_shared.MouseSafeArea, {
    parentRef: menuElementRef
  }), /*#__PURE__*/_react.default.createElement(ClayDropDownContext.Provider, {
    value: {
      back: function back() {
        var _triggerElementRef$cu;
        ((_triggerElementRef$cu = triggerElementRef.current) === null || _triggerElementRef$cu === void 0 ? void 0 : _triggerElementRef$cu.children[0]).focus();
        setVisible(false);
      },
      close: function close() {
        setVisible(false);
        _close();
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_FocusMenu.FocusMenu, {
    condition: visible,
    onRender: function onRender() {
      if (menuElementRef.current && keyboardRef.current) {
        var first = menuElementRef.current.querySelector(_shared.FOCUSABLE_ELEMENTS.join(','));
        if (first) {
          first.focus();
        }
      }
    }
  }, /*#__PURE__*/_react.default.createElement(DropDownItems, {
    items: items,
    spritemap: spritemap
  })))));
};
var RadioGroupContext = /*#__PURE__*/_react.default.createContext({});
var Radio = function Radio(_ref5) {
  var _ref5$value = _ref5.value,
    value = _ref5$value === void 0 ? '' : _ref5$value,
    otherProps = _objectWithoutProperties(_ref5, _excluded4);
  var _useContext4 = (0, _react.useContext)(RadioGroupContext),
    checked = _useContext4.checked,
    name = _useContext4.name,
    _onChange2 = _useContext4.onChange;
  var _useContext5 = (0, _react.useContext)(_DropDownContext.DropDownContext),
    tabFocus = _useContext5.tabFocus;
  return /*#__PURE__*/_react.default.createElement(_DropDown.default.Section, {
    role: "none"
  }, /*#__PURE__*/_react.default.createElement(_form.ClayRadio, _extends({}, otherProps, {
    checked: checked === value,
    inline: true,
    name: name,
    onChange: function onChange() {
      return _onChange2(value);
    },
    tabIndex: !tabFocus ? -1 : undefined,
    value: value
  })));
};
var RadioGroup = function RadioGroup(_ref6) {
  var items = _ref6.items,
    label = _ref6.label,
    name = _ref6.name,
    _ref6$onChange = _ref6.onChange,
    _onChange3 = _ref6$onChange === void 0 ? function () {} : _ref6$onChange,
    spritemap = _ref6.spritemap,
    _ref6$value = _ref6.value,
    defaultValue = _ref6$value === void 0 ? '' : _ref6$value;
  var _useState5 = (0, _react.useState)(defaultValue),
    _useState6 = _slicedToArray(_useState5, 2),
    value = _useState6[0],
    setValue = _useState6[1];
  var params = {
    checked: value,
    name: name,
    onChange: function onChange(value) {
      _onChange3(value);
      setValue(value);
    }
  };
  "production" !== "production" ? (0, _warning.default)(items && items.filter(function (item) {
    return item.type !== 'radio';
  }).length === 0, 'ClayDropDownWithItems -> Items of type `radiogroup` should be used `radio` if you need to use others, it is recommended to use type `group`.') : void 0;
  return /*#__PURE__*/_react.default.createElement(_Group.default, {
    header: label,
    role: "radiogroup"
  }, items && /*#__PURE__*/_react.default.createElement(RadioGroupContext.Provider, {
    value: params
  }, /*#__PURE__*/_react.default.createElement(Items, {
    items: items,
    spritemap: spritemap
  })));
};
var DividerWithItem = function DividerWithItem() {
  return /*#__PURE__*/_react.default.createElement(_Divider.default, null);
};
var TYPE_MAP = {
  checkbox: Checkbox,
  contextual: Contextual,
  divider: DividerWithItem,
  group: Group,
  item: Item,
  radio: Radio,
  radiogroup: RadioGroup
};
var DropDownItems = exports.DropDownItems = function DropDownItems(_ref7) {
  var items = _ref7.items,
    role = _ref7.role,
    spritemap = _ref7.spritemap,
    otherProps = _objectWithoutProperties(_ref7, _excluded5);
  return /*#__PURE__*/_react.default.createElement(_DropDown.default.ItemList, {
    "aria-label": otherProps['aria-label'],
    role: role
  }, /*#__PURE__*/_react.default.createElement(Items, {
    items: items,
    spritemap: spritemap
  }));
};
var Items = function Items(_ref8) {
  var items = _ref8.items,
    spritemap = _ref8.spritemap;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, items.map(function (_ref9, key) {
    var type = _ref9.type,
      item = _objectWithoutProperties(_ref9, _excluded6);
    var Item = TYPE_MAP[type || 'item'];
    return /*#__PURE__*/_react.default.createElement(Item, _extends({}, item, {
      key: key,
      spritemap: spritemap
    }));
  }));
};